const inputSelector = '.chat-settings__input';

export function getSystemPrompt() {
    const systemPrompt = document.querySelector(inputSelector);
    if (systemPrompt) {
        return systemPrompt.value;
    }
    return null;
}